<template>
  <div class="main_ad">
    <div style="padding: 0px 20px">
      <div class="search">
        <div class="search_box">
          <div class="page_title">广告主管理</div>
          <div class="search_btn_box">
            <button :class='["search_btn","add","icon_btn","clearborder"]'><span class="el-icon-circle-plus-outline"></span>新增</button>
            <button :class='["search_btn","download","icon_btn","clearborder"]'><span class="el-icon-download"></span>下载</button>
            <button :class='["search_btn","delete","icon_btn","clearborder"]'><span class="el-icon-delete"></span>删除</button>
          </div>
        </div>
      </div>

      <!--        表格-->
      <div class="table_content">
        <table>
          <thead>
          <tr>
            <th style="padding-left: 30px"></th>
            <th>序号</th>
            <th>广告名称</th>
            <th>广告主名称</th>
            <th>投放详情</th>
            <th>联系人</th>
            <th>联系电话</th>
            <th>电子邮箱</th>
            <th>公司地址</th>
            <th style="padding-right: 30px">修改</th>
          </tr>
          </thead>
          <tbody>
          <tr  v-for="(item,index) in tabledata">
            <td style="padding-left: 30px"><input type="checkbox" name="checkbox"></td>
            <td>{{index + 1}}</td>
            <td>{{item.name}}</td>
            <td>{{item.company}}</td>
            <td>{{item.type}}</td>
            <td>{{item.contact}}</td>
            <td>{{item.phone}}</td>
            <td>{{item.email}}</td>
            <td>{{item.address }}</td>
            <td style="padding-right: 30px">修改</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="table_paging">
        <p>当前记录<span>1</span>到<span>5</span>条，共<span>45</span>条记录
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
          第<span>1</span>/<span>5</span>页
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
        </p>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    name: "main_ad",
    data() {
      return {
        tabledata: [
        //   {
        //     name: "广告001",
        //     company: "尤尼珠宝有限公司",
        //     type: "5s,一个月，10000元",
        //     contact: "张三蜂",
        //     phone: "15623136958",
        //     email: "456878967@qq.com",
        //     address: "石家庄市桥西区智达光电研发中心"
        //   },{
        //     name: "广告001",
        //     company: "尤尼珠宝有限公司",
        //     type: "5s,一个月，10000元",
        //     contact: "张三蜂",
        //     phone: "15623136958",
        //     email: "456878967@qq.com",
        //     address: "石家庄市桥西区智达光电研发中心"
        //   },{
        //     name: "广告001",
        //     company: "尤尼珠宝有限公司",
        //     type: "5s,一个月，10000元",
        //     contact: "张三蜂",
        //     phone: "15623136958",
        //     email: "456878967@qq.com",
        //     address: "石家庄市桥西区智达光电研发中心"
        //   },{
        //     name: "广告001",
        //     company: "尤尼珠宝有限公司",
        //     type: "5s,一个月，10000元",
        //     contact: "张三蜂",
        //     phone: "15623136958",
        //     email: "456878967@qq.com",
        //     address: "石家庄市桥西区智达光电研发中心"
        //   },{
        //     name: "广告001",
        //     company: "尤尼珠宝有限公司",
        //     type: "5s,一个月，10000元",
        //     contact: "张三蜂",
        //     phone: "15623136958",
        //     email: "456878967@qq.com",
        //     address: "石家庄市桥西区智达光电研发中心"
        //   },{
        //     name: "广告001",
        //     company: "尤尼珠宝有限公司",
        //     type: "5s,一个月，10000元",
        //     contact: "张三蜂",
        //     phone: "15623136958",
        //     email: "456878967@qq.com",
        //     address: "石家庄市桥西区智达光电研发中心"
        //   },{
        //     name: "广告001",
        //     company: "尤尼珠宝有限公司",
        //     type: "5s,一个月，10000元",
        //     contact: "张三蜂",
        //     phone: "15623136958",
        //     email: "456878967@qq.com",
        //     address: "石家庄市桥西区智达光电研发中心"
        //   },{
        //     name: "广告001",
        //     company: "尤尼珠宝有限公司",
        //     type: "5s,一个月，10000元",
        //     contact: "张三蜂",
        //     phone: "15623136958",
        //     email: "456878967@qq.com",
        //     address: "石家庄市桥西区智达光电研发中心"
        //   },{
        //     name: "广告001",
        //     company: "尤尼珠宝有限公司",
        //     type: "5s,一个月，10000元",
        //     contact: "张三蜂",
        //     phone: "15623136958",
        //     email: "456878967@qq.com",
        //     address: "石家庄市桥西区智达光电研发中心"
        //   }
        ]
      }
    },
    methods:{
      InitLeftMenu: function () {
        this.$emit('getMessage', '4', '4');
      },
      //获取列表
      GetDataList:function(){
        fetch("/api/v1/material/list/", {
          method: 'post',
          body: JSON.stringify({
            "advert_id" : "",
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            this.tabledata = data.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
    },
    created() {
      this.InitLeftMenu();
    }
  }
</script>

<style scoped>
  .main_ad{
    width: 100%;
    height: 100%;
  }

  .search {
    width: 100%;
    height: 100px;
    padding: 20px 0px 0px;
  }

  .search_box {
    width: 100%;
    height: 100%;
    margin-right: 10px;
    background: #16518d;
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    position: relative;
  }

  .search_options_box {
    width: 20%;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #ffffff;
    color: #ffffff;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 48px;
    right: 20px;
    cursor: pointer;
  }

  .search_btn_box {
    /*width: 370px;*/
    padding: 10px;
    position: absolute;
    right: 0px;
  }

  .clearborder {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_btn {
    width: 110px;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
    float: right;
    margin-right: 20px;
  }

  .icon_btn span {
    margin-right: 8px;
  }

  .add {
    background: #7aafeb;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #3574ba;
  }

  .add:active {
    background: #6ca3e2;
  }

  .download {
    background: #21b868;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #18884d;
  }

  .download:active {
    background: #19ad5f;
  }

  .delete {
    background: #f2ae4d;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #dc8509;
  }

  .delete:active {
    background: #e7a342;
  }

  .page_title{
    font-size: 20px;
    color: #FFFFFF;
    font-weight: bold;
    margin-left: 30px;
  }

  .table_content{
    width: 100%;
    height: calc(100% - 100px);
    padding: 20px 0px;
  }

  .table_content > table {
    width: 100%;
    height: 100%;
    border: 1px solid #094b8e;
    background-color: #16518d;
  }

  .table_content > table tr th{
    background-color: #0e345b;
  }
  .table_content > table tr td{
    /*background-color: #16518d;*/
  }

  .table_content > table tr td input{
    width: 16px;
    height: 16px;

  }

  .table_content > table tr:nth-child(2n){
    background-color: #11406f;
  }

  .table_content > table tr {
    /*border-bottom: 1px solid #225892;*/
    height: 62px
  }

  .table_content > table tr td, .table_content > table tr th {
    text-align: center;
    color: #FFFFFF;
  }

  .table_paging {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid #105ba8;
    border-radius: 6px;
  }

  .table_paging > p {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin-bottom: 0;
    color: #c1c2c6;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .table_paging > p > button {
    margin: 0 8px;
    width: 10px;
    height: 16px;
    border: none;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/5_msg/main_ad.vue